import { render, staticRenderFns } from "./InputWithLabel.vue?vue&type=template&id=5deab6bb&scoped=true&lang=pug&"
import script from "./InputWithLabel.vue?vue&type=script&lang=ts&"
export * from "./InputWithLabel.vue?vue&type=script&lang=ts&"
import style0 from "./InputWithLabel.vue?vue&type=style&index=0&id=5deab6bb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deab6bb",
  null
  
)

export default component.exports